// extracted by mini-css-extract-plugin
export var attachment = "_sc-a";
export var emailContainer = "_sc-4";
export var emailContentPaddedContainer = "_sc-b";
export var emailHeader = "_sc-6";
export var emailIframe = "_sc-3";
export var emailInfoIcon = "_sc-9";
export var emailShortenedSummary = "_sc-e";
export var infoDropdown = "_sc-0";
export var infoRowBoundedContent = "_sc-d";
export var internal = "_sc-5";
export var merchant = "_sc-8";
export var messageInputContainer = "_sc-h";
export var normal = "_sc-7";
export var replyCard = "_sc-f";
export var subtleButton = "_sc-1";
export var subtleButtonIconContainer = "_sc-2";
export var toggleViewRepliesButton = "_sc-c";
export var wrappingText = "_sc-g";